<template>
    <div class="main-article">
        <div class="article">
            <p class="sub-title">版权登记介绍</p>
            <p class="paragraph">
                北京版权认证中心作为首都版权协会的内设机构，主要工作内容涵盖推进版权社会服务体系建设，贯彻执行党和国家的发展路线、方针。协助企业及各权利人完成著作权确权、以及版权保护相关工作；依法维护各类权利人的合法权益，促进版权产业的繁荣和发展。为了更好的帮助企业、个人等权利人维护自身合法利益，在遭受著作权侵权纠纷时，可以提供有效的权属证明文件。北京版权认证中心推出一站式快速在线办理作品登记机制。旨在为企业、个人提供便捷、快速的服务模式。
            </p>
            <p class="paragraph">
                根据国家版权局《作品自愿登记试行办法》的有关规定，凡作者、其他享有著作权的公民、法人或者非法人单位和专有权的所有人及其代理人，均可申请作品登记
            </p>

            <p class="sub-title">可以申请著作权登记的作品包括</p>
            <p class="paragraph">
                （1）文字作品；（2）口述作品；（3）音乐、 戏剧、 曲艺、舞蹈、杂技艺术作品；（4）美术、建筑作品；（5）摄影作品；（6）电影作品和以类似摄制电影的方法创作的作品； （7）工程设计图、产品设计图、地图、示意图等图形作品和模型作品；（8）计算机软件；（9）法律、行政法规规定的其它作品。
            </p>

        </div>
        <div class="article-picture">
            <div style="width: 400px;height: 300px;margin-top: 60px;">
                <img :src="article11"/>
            </div>
            <div style="width: 400px;height: 300px;margin-top: 60px;">
                <img :src="article12"/>
            </div>
        </div>
    </div>
</template>

<script>
    import article11 from '@/assets/images/v2/article/article1-1.png';
    import article12 from '@/assets/images/v2/article/article1-2.png';
    export default{
        name:"article1",
        data(){
            return{
                article11,
                article12
            }
        }
    }
</script>
<style lang="less" scoped>
    .main-article{
        display: flex;

    }
    .article{
        flex: 1;
        .sub-title{
            font-family: Source Han Sans CN;
            font-size: 24px;
            font-weight: 700;
            line-height: 36px;
            text-align: left;
            color: #666;
            padding: 90px 0 30px 0;
        }
        .paragraph{
            color: #999;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-weight: 700;
            line-height: 30px;
            text-align: left;
            text-indent: 28px;
            width: 664px;
        }
    }
</style>